export enum OnboardingIndividualSuccessCodes {
  ONBOARD_SUCCESS = 'onboard_success',
}
